const withInertiaStopped = (fn) => {
  const html = document.documentElement, prevOverflowHTML = html.style.overflow
  const body = document.body, prevOverflowBody = body.style.overflow
  html.style.overflow = 'hidden'
  body.style.overflow = 'hidden'
  setTimeout(() => {
    html.style.overflow = prevOverflowHTML
    body.style.overflow = prevOverflowBody
    fn()
  }, 50)
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    static threshold = 450;
    static opacityPadding = 50;

    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }

      const gallery = this.querySelector('.product__media-list')
      const children = gallery.querySelectorAll('li')
      const dotContainer = this.querySelector('.container-dot')
      children.forEach(() => {
        const dot = document.createElement('span')
        dot.classList.add('dot')
        //dotContainer.appendChild(dot)
      })
      
      // Eliminamos el scrollCheckDot original y lo reemplazamos por uno más simple
      const scrollCheckDot = (gallery, dotContainer) => {
        const height = gallery.offsetHeight
        const scrollPosition = gallery.scrollLeft
        const scrollWidth = gallery.scrollWidth
        const position = Math.round(scrollPosition / gallery.offsetWidth);

        dotContainer.querySelector('.active')?.classList.remove('active')
        dotContainer.querySelectorAll('span')[position]?.classList.add('active')
      }

      // Cambiamos el evento de scroll para usar scrollLeft en móvil
      //if (window.innerWidth < 750) {
      //  gallery.addEventListener('scroll', (event) => {
      //    scrollCheckDot(gallery, dotContainer)
      //  }, { passive: true })
      //} else {
        // Comportamiento original para escritorio
        gallery.addEventListener('scroll', (event) => {
          const height = gallery.offsetHeight
          const scrollPosition = gallery.scrollTop
          const position = Math.round(scrollPosition / height);
          
          dotContainer.querySelector('.active')?.classList.remove('active')
          dotContainer.querySelectorAll('span')[position]?.classList.add('active')
        }, { passive: true })
      //}

      this.mql = window.matchMedia('(min-width: 750px)');
      if (this.elements.thumbnails) {
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
    }

    // Resto de los métodos permanecen igual...
    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    // ...otros métodos permanecen igual
  });
}